export default function OrderingServices() {
  return (
    <p>
      The registration pages of the site will guide the Customer through the steps needed to register and to place an order for Services.
      The order process allows the Customer to check and amend any errors before submitting the order and the Customer agrees to take the
      time to read and check their order at each page of the order process.
      <br /><br />
      Upon signing up for a trial or otherwise placing an order, the Customer will receive an e-mail from the Information Service Provider
      acknowledging that the order has been received.  The acceptance of the order will take place as described in the clause below.
      <br /><br />
      The Information Service Provider will confirm its acceptance of the order by sending an activation e-mail to the Customer.
      This email may take up to 24 hours to be processed by the Information Service Provider and, where initial fees are due in advance of activation,
      will be subject to the Information Service Provider’s receipt of such initial fees.  The Contract for Services between the Customer and the
      Information Service Provider will only be formed when the activation email is sent and the date on which such email is sent shall constitute the
      “Commencement Date” for the purposes of the Contract for Services.
      <br /><br />
      If the Information Service Provider is unable to supply particular services, for example because that service is no longer available or because of
      an error in the price on the site (as referred to in the Fees and Payment clause below), the Information Service Provider will inform the Customer
      of this by e-mail and will not process the order for those services. If initial fees were due in advance of activation for such services and the
      Customer has already paid for those services, the Information Service Provider will, as soon as possible, refund the full amount paid in relation
      to the Services that cannot be provided.
    </p>
  );
}
